module.exports = __webpack_public_path__ + "img/utensils-crossed.ac9d7947.svg";